import { useContext, useEffect } from 'react';
import { TopHeader } from '../components/common';
import { DescriptionContainer, FormContainer } from '../components/creator-form';
import { verifyInboundEnabled } from '../services/inbound.service';
import styles from '../styles/creatorForm.module.css';
import { InboundContext } from '../context/InboundContext';

export default function CreatorForm() {
  const { subDomainSuffix } = useContext(InboundContext);
  const handleBeforeUnload = (e: any) => {
    e.preventDefault();
    const message = 'Are you sure you want to leave? All provided data will be lost.';
    e.returnValue = message;
    return message;
  };

  useEffect(() => {
    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('popstate', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('popstate', handleBeforeUnload);
    };
  }, []);

  const verifyDomain = async (suffix: string) => {
    const response = await verifyInboundEnabled(suffix);
    if (!response.success) {
      window.location.href = '/forbidden';
    }
  };

  useEffect(() => {
    if (subDomainSuffix) {
      verifyDomain(subDomainSuffix);
    }
  }, [subDomainSuffix]);

  return (
    <div>
      <TopHeader />
      <div className={styles.mainContainer}>
        <DescriptionContainer />
        <FormContainer />
      </div>
    </div>
  );
}
